import * as React from "react";
import { endOfDay, format } from "date-fns";

import {
  CamIcon,
  ClockIcon,
  HospitalIcon,
  Spinner,
} from "../../shared/svgIcon";

import { useRef } from "react";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { updateAppointmentStatus } from "../../lib/api";
import { useStore } from "../../store";
import { useAppointmentsMiscellaneous } from "../../shared/utils";

export function AppointmentDetail(props) {
  let navigate = useNavigate();
  const { appointmentId } = useParams();
  const selectedDateRef = useRef(null);
  const selectedTimeRef = useRef(null);
  const selectedAppointment = useStore((state) => state.selectedAppointment);

  const [currentDoctor, setCurrentDoctor] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedTime, setSelectedTime] = React.useState(null);
  const [locationDetail, setLocationDetail] = React.useState(null);
  const [selectedType, setSelectedType] = React.useState(null);
  const [appointmentStatus, setAppointmentStatus] = React.useState(null);
  const [isLoading, setLoader] = React.useState(false);
  const { data: appointmentsMisc } = useAppointmentsMiscellaneous();

  useEffect(() => {
    // console.log(id, "id");
    if (selectedAppointment) {
      setCurrentDoctor(selectedAppointment?.user);
      setLocationDetail(selectedAppointment?.organization);
      setSelectedDate(selectedAppointment?.start_time);
      setSelectedTime({
        slot_start: selectedAppointment?.start_time,
        slot_end: selectedAppointment?.end_time,
      });
      setSelectedType(selectedAppointment?.appointment_type);
      setAppointmentStatus(selectedAppointment?.status);
    }

    // console.log(selectedAppointment, "selectedAppointment");
  }, []);

  useEffect(() => {
    if (selectedDateRef.current) {
      selectedDateRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedDate]);
  useEffect(() => {
    if (selectedTimeRef.current) {
      selectedTimeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedTime]);
  const getStatus = (key) => {
    return appointmentsMisc?.data?.result?.appointment_status_types?.filter(
      (e) => e.key === key
    )[0]?.label;
  };

  const CancelAppointment = async () => {
    // console.log(selectedDate, "schedule", selectedTime, currentDoctor);
    if (selectedDate && selectedTime && currentDoctor) {

      setLoader(true);

      const payload = {
        status: "canceled",
      };
      const res = await updateAppointmentStatus(appointmentId, payload);

      // console.log(payload, "payload");

      if (res.isSuccess) {
        setLoader(false);
        navigate("/Dashboard");
      } else {
        setLoader(false);
      }
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };
  const goToVitalHistory = () => {
    navigate("/vitalHistory?from=share");
  };
  const goToDocHistory = () => {
    navigate("/documentHistory?from=share");
  };

  const startCall = (e) => {
    sessionStorage.setItem(
      "selectedAppointment",
      JSON.stringify(selectedAppointment)
    );
    navigate("/videoCall");
  };

  return (
    <>
      <div className="bg-white min-sh-screen ">
        <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-white ">
          <div>
            <Link className="flex" to="#" onClick={handleGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
              <div className="pl-2 flex-1 mt-0.5">
                <h4 className="font-semibold text-sm">Appointment Details</h4>
              </div>
            </Link>
          </div>
        </div>
        <div
          className=" flex-1  hideScroll  text-gray-500  flex flex-col pt-16 p-4 pb-16"
          // style={{ height: "calc(100vh - 10px)" }}
        >
          {selectedAppointment && (
            <>
              <div
                className={`bg-neutral-100  border shadow  rounded-[18px] p-4 mb-8 w-`}
              >
                <div className="flex   justify-between ">
                  <div className="flex ">
                    <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
                      {currentDoctor?.profile.avatar_url ? (
                        <img
                          className="w-full h-full object-cover"
                          src={currentDoctor?.profile.avatar_url}
                          alt={currentDoctor?.username}
                        />
                      ) : (
                        <img
                          className="w-full h-full object-cover"
                          src={"../../../images/user.svg"}
                          alt={currentDoctor?.username}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flex  flex-col flex-1 pl-2">
                    <div className="flex flex-col p-2 ">
                      <div className="font-semibold text-slate-700">
                        {" "}
                        {currentDoctor?.name_prefix}{" "}
                        {currentDoctor?.profile.first_name}{" "}
                        {currentDoctor?.profile.middle_name}{" "}
                        {currentDoctor?.profile.last_name}
                      </div>
                      <div className="text-sm text-zinc-600 ">
                        {currentDoctor?.qualifications &&
                          currentDoctor?.qualifications.map(
                            (qualification, index) => (
                              <div key={index}>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal"
                                >
                                  {qualification}
                                </span>{" "}
                                {index <
                                  currentDoctor?.qualifications.length - 1 && (
                                  <span className="pr-1">,</span>
                                )}
                              </div>
                            )
                          )}
                        {currentDoctor?.specialities &&
                          currentDoctor?.specialities.map(
                            (specialty, index) => (
                              <div key={index}>
                                <span className="pr-1">,</span>
                                <span
                                  key={index}
                                  className="text-neutral-500 text-sm font-normal "
                                >
                                  {specialty?.name}
                                </span>{" "}
                                {index <
                                  currentDoctor?.specialities.length - 1 && (
                                  <span className="pr-1">,</span>
                                )}
                              </div>
                            )
                          )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between py-2">
                      <div className="flex flex-col h-full justify-between">
                        <div className="font-semibold text-slate-700 mb-2">
                          Type
                        </div>
                        <div
                          className={`flex items-center cursor-pointer  text-sm text-white  py-1 px-2 rounded-xl border w-[110px] ${
                            selectedType == "virtual_visit"
                              ? "bg-green-500  border-green-500"
                              : "bg-orange-500 border-orange-500"
                          }`}
                          onClick={(e) => {
                            if (selectedType == "virtual_visit") startCall();
                          }}
                        >
                          {selectedType == "virtual_visit" ? (
                            <CamIcon />
                          ) : (
                            <HospitalIcon />
                          )}{" "}
                          <p className="px-1">
                            {selectedType == "virtual_visit"
                              ? "Video call"
                              : "In Person"}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col h-full justify-between ml-4">
                        <div className="font-semibold text-slate-700 mb-2">
                          Status
                        </div>
                        <div
                          className={` text-sm rounded-full  text-slate-700`}
                        >
                          {getStatus(appointmentStatus)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full h-[0px] border-b-[1px] border-indigo-200 mb-2"></div>
                {selectedAppointment?.reason && <div className=" p-3 pb-1 mb-1  mt-1">
                  <div className="text-base font-semibold">
                    Reason for the visit
                  </div>
                  <span className="">
                      {selectedAppointment?.reason}
                    </span>
                </div>}
                <div className=" p-3 mb-4  mt-1">
                  <div className="text-base font-semibold">
                    {locationDetail?.name}
                  </div>

                  <div className="">
                    {/* <span className="pr-2">
                      {locationDetail?.location}{" "}
                    </span> */}
                    <span className="pr-2">
                      {locationDetail?.address?.street},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.address?.city},
                    </span>
                    <span className="pr-2">
                      {locationDetail?.address?.state}
                    </span>

                    <span className="pr-2">
                      {locationDetail?.address?.postal_code}
                    </span>
                  </div>

                  {locationDetail?.contact?.filter((e) => e.type == "phone")
                    .length > 0 && (
                    <div className="location-phone webmd-row">
                      Tel:{" "}
                      <a
                        href={`tel:${
                          locationDetail?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }`}
                        className=""
                      >
                        {
                          locationDetail?.contact?.find(
                            (contact) => contact.type === "phone"
                          )?.value
                        }
                      </a>
                    </div>
                  )}
                </div>
                <div className="text-sm font-semibold flex flex-col min-[420px]:flex-row min-[420px]:items-center text-slate-700">
                  {selectedDate && (
                    <div className="flex items-center">
                      <ClockIcon className="mr-2" />
                      <p className="pr-1 font-semibold text-base">
                        {format(new Date(selectedDate), "MMM")}
                      </p>
                      <p className="font-semibold text-base">
                        {format(new Date(selectedDate), "dd")}
                      </p>
                      ,
                      <p className="pr-1 font-semibold text-base">
                        {format(new Date(selectedDate), "yyyy")}
                      </p>
                      <p className="pl-3 font-semibold text-base">
                        {format(new Date(selectedDate), "EEE")}
                      </p>
                      ,
                    </div>
                  )}
                  {/* <p className="px-1">{format(new Date(), "h:mm a")}</p> */}
                  {selectedTime && (
                    <div className="flex flex-row gap-2 font-semibold text-base pl-1">
                      <p>
                        {" "}
                        {format(new Date(selectedTime.slot_start), "h:mm a")}
                      </p>{" "}
                      <p>-</p>
                      <p>
                        {" "}
                        {format(new Date(selectedTime.slot_end), "h:mm a")}
                      </p>
                    </div>
                  )}
                </div>
                <div className="flex flex-1 justify-around space-x-4 mt-6">
                  <button
                    className="border-2 bg-blue-800 rounded-[18px] text-white py-2 px-4 text-center  text-base"
                    onClick={goToVitalHistory}
                  >
                    Send Vitals
                  </button>
                  <button
                    className="border-2 bg-blue-800 rounded-[18px] text-white py-2 px-4 text-center  text-base"
                    onClick={goToDocHistory}
                  >
                    Share Documents
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="bg-white h-16 fixed bottom-0 w-full  flex justify-center">
          <button
            onClick={CancelAppointment}
            className="  w-11/12 h-14 p-3 bg-blue-800 rounded-[18px] text-white font-semibold"
          >
            {isLoading && <Spinner className="mr-2 h-4 w-4 animate-spin" />}{" "}
            Cancel appointment
          </button>
        </div>
      </div>
    </>
  );
}
